import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import NotFound from "../views/NotFound.vue";
import EmptTimeResult from "../views/driver/EmptTimeResult.vue";
import SuspensionInstructions from "../views/passenger/SuspensionInstructions.vue";
import QuestionsAndAnswers from "../views/passenger/QuestionsAndAnswers.vue";
import PrivacyProtectionPolicy from "../views/PrivacyProtectionPolicy.vue";
import TermsOfService from "../views/TermsOfService.vue";
import OrderDetailView from "../views/driver/OrderDetailView.vue";
import OrderDetailEmptyView from "../views/driver/OrderDetailEmptyView.vue";
import OrderStatisticsView from "../views/driver/OrderStatisticsView.vue";
import PageTitleGuards from "./guards/PageTitleGuards";
import BodyClassGuards from "./guards/BodyClassGuards";

const routes: RouteRecordRaw[] = [
  {
    path: "/driver/empt-time-result",
    redirect: "/driver/empty-time-result",
  },
  {
    path: "/driver/empty-time-result",
    name: "EmptTimeResult",
    component: EmptTimeResult,
    meta: { title: "司機空閒時段回報" },
  },
  {
    path: "/driver/order-detail-view",
    name: "OrderDetailEmptyView",
    component: OrderDetailEmptyView,
    meta: { title: "訂單細節", bodyClass: "bg-background" },
  },
  {
    path: "/driver/order-detail-view/:orderno",
    name: "OrderDetailView",
    component: OrderDetailView,
    meta: { title: "訂單細節", bodyClass: "bg-background" },
  },
  {
    path: "/driver/order-statistics/:type/:date",
    name: "OrderStatisticsView",
    component: OrderStatisticsView,
    meta: { title: "訂單紀錄" },
  },
  {
    path: "/passenger/suspension-instructions",
    name: "SuspensionInstructions",
    component: SuspensionInstructions,
    meta: { title: "停權說明", bodyClass: "bg-background" },
  },
  {
    path: "/passenger/questions-and-answers",
    name: "QuestionsAndAnswers",
    component: QuestionsAndAnswers,
    meta: { title: "操作Q&A" },
  },
  {
    path: "/privacy-protection-policy",
    name: "PrivacyProtectionPolicy",
    component: PrivacyProtectionPolicy,
    meta: { title: "隱私保護政策" },
  },
  {
    path: "/terms-of-service",
    name: "TermsOfService",
    component: TermsOfService,
    meta: { title: "服務條款" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from) => {
  PageTitleGuards.BeforeEach(to);
  BodyClassGuards.BeforeEach(to, from);
});

export default router;
